// extracted by mini-css-extract-plugin
module.exports = {"image_container":"test_right_side_image_container__2Q9ny","default_image":"test_right_side_default_image__7kvlq","content_container":"test_right_side_content_container__1u6et"};